/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class PublicAccessService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get Public Access Info
     * Get information about public access configuration
     *
     * This endpoint is publicly accessible and returns information about
     * which value chains can be accessed without authentication.
     *
     * Solar Photovoltaic (PV) System is always public.
     * The system automatically finds it in Neo4j on startup.
     *
     * Returns:
     * Public access configuration
     * @returns any Successful Response
     * @throws ApiError
     */
    public getPublicAccessInfoApiV1PublicAccessInfoGet(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/public/access-info',
        });
    }
    /**
     * Check Requires Auth
     * Check if a specific value chain requires authentication
     *
     * Args:
     * element_id: The element_id of the value chain to check
     *
     * Returns:
     * Whether authentication is required
     * @param elementId
     * @returns any Successful Response
     * @throws ApiError
     */
    public checkRequiresAuthApiV1PublicRequiresAuthElementIdGet(
        elementId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/v1/public/requires-auth/{element_id}',
            path: {
                'element_id': elementId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Refresh Public Access Cache
     * Refresh the public value chain cache
     *
     * This endpoint forces the system to re-query Neo4j for the Solar PV System.
     * Useful if the Solar PV System is added or modified in Neo4j.
     *
     * Returns:
     * Updated public access information
     * @returns any Successful Response
     * @throws ApiError
     */
    public refreshPublicAccessCacheApiV1PublicRefreshCachePost(): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/v1/public/refresh-cache',
        });
    }
}
